module.exports = __webpack_public_path__ + "img/17.61b21cc1.jpg";